import { useEffect } from 'react'

import { useNavBar } from 'hooks/useNavBar'
import { ActionIconEnum } from 'common/enums/ActionIcon'
import image from 'assets/png/purchase.png'
import { Icons } from 'utils/icons'
import { PartnerLogo } from 'components'
import { useHistory } from 'react-router-dom'
import { TypesRoutes } from 'routes/mixedRoutes/types'
import useBoundState from 'store'

import { uuid } from '@interco/inter-ui'
import { Text } from '@interco/inter-ui/components/Text'
import { Button } from '@interco/inter-ui/components/Button'

import * as S from './PurchaseConfirmation.styles'
import {
  AnalyticsPurchaseConfirmation,
  AnalyticsScratchNow,
  AnalyticsSeeReceipt as AnalyticsCheckReceipt,
} from './PurchaseConfirmation.tags'

export const PurchaseConfirmation = () => {
  const history = useHistory()

  const getTickets = useBoundState((state) => state.getTickets)

  const checkIcon = <Icons.Check color="var(--gray500)" width={24} height={24} />

  useEffect(() => {
    getTickets()
  }, [getTickets])

  useEffect(() => {
    AnalyticsPurchaseConfirmation()
  }, [])

  useNavBar({
    actionIcons: {
      rightIcon: ActionIconEnum.CLOSE,
    },
  })

  const advantagesData = [
    {
      icon: checkIcon,
      description: 'Tem sorteio de R$ 7.000,00 todo mês.',
    },
    {
      icon: checkIcon,
      description: 'Você dobra suas chances de ganhar a cada 3 meses com 1 sorteio extra.',
    },
    {
      icon: checkIcon,
      description: `Agora é só torcer!`,
    },
  ]

  const handleStartGame = () => {
    AnalyticsScratchNow()
    history.push(TypesRoutes.START)
  }

  const handleCheckReceipt = () => {
    AnalyticsCheckReceipt()
    history.push(TypesRoutes.LANDING_PAGE_RECEIPT)
  }

  return (
    <S.Container>
      <S.HeroImage>
        <img
          src={image}
          alt="Imagem contem um rapaz com uma expressão feliz segurando um celular"
        />
      </S.HeroImage>

      <S.Section>
        <S.AdvantagesList data-testid="advantages-list">
          <Text variant="headline-h1" as="h1" semiBold>
            Parabéns! Você já está participando dos sorteios
          </Text>

          {advantagesData.map((advantage) => (
            <S.Advantages key={uuid()}>
              {advantage.icon}
              <Text variant="body-3" weight={400}>
                {advantage.description}
              </Text>
            </S.Advantages>
          ))}
        </S.AdvantagesList>
      </S.Section>

      <S.Footer>
        <PartnerLogo />

        <Button fullWidth onClick={handleStartGame}>
          Raspar
        </Button>
        <Button fullWidth variant="secondary" onClick={handleCheckReceipt}>
          Conferir comprovante
        </Button>
      </S.Footer>
    </S.Container>
  )
}
